import * as React from 'react';
import { ItemFieldProps } from './types';
import { Field, getValue } from './field';
import { TrueCheck } from '../../../Icon/icon';

export const BooleanField = ({ item, fieldInfo }: ItemFieldProps) => {
  const value = getValue(item, fieldInfo?.schemaField);
  if (!value) return null;
  return (
    <Field fieldInfo={fieldInfo}>
      <label>
        <TrueCheck />
      </label>
      {fieldInfo.schemaField.name}
    </Field>
  );
};
